import {
	GET_LIST_KICK_POINT_REDEMPTION,
	GET_DETAIL_KICK_POINT_REDEMPTION,
	ADD_KICK_POINT_REDEMPTION,
	UPDATE_KICK_POINT_REDEMPTION,
	DELETE_KICK_POINT_REDEMPTION,
	NEW_KICK_POINT_REDEMPTION,
	FETCHING_KICK_POINT_REDEMPTION,
	KICK_POINT_REDEMPTION_ERROR
} from '../constants';

/**
 * Initial State
 */
const initialState = {
	list: [],
	detail: {},
	isFetch: false,
	isSubmit: false,
	error: null,
	success: null,
}

const onGetList = (lastState, payload) => {
	const { data, message, status_code } = payload;
	return { ...lastState, error: null, success: null, detail: {}, list: { ...data, message, status_code } };
}

const onGetDetail = (lastState, payload) => {
	const { data, message, status_code } = payload;
	return { ...lastState, error: null, success: null, detail: { ...data, message, status_code } };
}

const onFetching = (lastState, payload) => {
	if (payload.type === 'fetch')
		return { ...lastState, isFetch: payload.status }
	else if (payload.type === 'submit')
		return { ...lastState, isSubmit: payload.status }
	return { ...lastState, isFetch: false, isSubmit: false }
}

const onError = (lastState, payload) => {
	const { error, id } = payload
	return { ...lastState, error: { ...error, id }, success: null };
}

const onAdd = (lastState, payload) => {
	const { data, message, status_code } = payload;
	return { ...lastState, detail: { ...data, message, status_code }, success: 'Insert has been successfully!', error: null }
}

const onUpdate = (lastState, payload) => {
	const { data, message, status_code } = payload;
	return { ...lastState, detail: { ...data, message, status_code }, success: 'Update has been successfully!', error: null }
}

const onDelete = (lastState, payload) => {
	const { data, message, status_code } = payload;
	return { ...lastState, detail: { ...data, message, status_code, delete: true }, success: 'Delete has been successfully!', error: null }
}

const kickPointRedemptionReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_LIST_KICK_POINT_REDEMPTION: return onGetList(state, action.payload);
		case GET_DETAIL_KICK_POINT_REDEMPTION: return onGetDetail(state, action.payload);
		case FETCHING_KICK_POINT_REDEMPTION: return onFetching(state, action.payload);
		case KICK_POINT_REDEMPTION_ERROR: return onError(state, action.payload);
		case ADD_KICK_POINT_REDEMPTION: return onAdd(state, action.payload);
		case UPDATE_KICK_POINT_REDEMPTION: return onUpdate(state, action.payload);
		case DELETE_KICK_POINT_REDEMPTION: return onDelete(state, action.payload);
		case NEW_KICK_POINT_REDEMPTION: return initialState;
		default: return state;
	}
}

export default kickPointRedemptionReducer;
